
<template>
  <div class="review-result-wrapper">
    <img
      v-if="isHalf"
      src="https://vanthink.oss-cn-qingdao.aliyuncs.com/27ce2d6b2363dc9a1799463d2973729a.png" alt="">
    <img
      v-else
      src="https://vanthink.oss-cn-qingdao.aliyuncs.com/ddf2247d313ad82b470a8e55982b6694.png" alt="">
    <div class="describe">
      <div v-if="isHalf" class="scene-describe">
        已经复习了这么多内容啦，要不要休息一会儿去学习一下新的内容呢！<br/>当然你也可以继续复习哦！
      </div>
      <div v-else class="scene-describe">本次学习了{{result.length}}道大题，用时{{time}}</div>
    </div>
    <div class="scene-control">
      <template v-if="isHalf">
        <div
          class="btn btn-orange-square btn-circle"
          @click="start"
        >继续学习</div>
        <div
          class="btn btn-blue-square"
          @click="close">前往学习</div>
      </template>
      <div
        v-else
        class="btn btn-orange-square btn-circle"
        @click="close"
      >关闭</div>
    </div>
  </div>
</template>

<script>
import utils from '@/services/utils';

export default {
  props: {
    isHalf: {
      type: Boolean,
      default: false,
    },
    result: {
      type: Array,
      default: () => [],
    },
    spendTime: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    time() {
      return utils.secondsToTime(this.spendTime);
    },
  },
  methods: {
    start() {
      this.$emit('continue');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  .review-result-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/5f520b088c1ee76419426c5b42337714.png')
      no-repeat center center / cover;
    img {
      width: 25%;
    }
    .scene-describe {
      margin-top: 2vh;
      font-size: 2.5vh;
      line-height: 1.5;
    }
    .scene-control {
      margin: 5vh 0;
      display: flex;
      justify-content: center;
      width: 100%;
      .btn {
        margin: 0 4vh;
        width: 20vh;
        height: 6vh;
        font-size: 2.5vh;
        border-radius: 30px;
      }
    }
  }
</style>
